export default __webpack_public_path__ + "locales/lo-LA/JavascriptSdk.json?hash=f364d4d96a10aa56bd16dbc01366162b";